import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import { SearchSuggestionService } from '@hdms/shared/page-frame/data-access';
import { VisibilityComponentAbstract } from '@hdms/shared/ui-core';
import { BackDropClass, WindowRefService } from '@hdms/shared/util-core';

import { SearchSuggestionKeyboardControlService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-search-mobile',
  templateUrl: './search-mobile.component.html',
  styleUrls: ['./search-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SearchMobileComponent extends VisibilityComponentAbstract {
  readonly suggestions$ = this.suggestionService.suggestions$;
  readonly isLoading$ = this.suggestionService.isLoading$();

  get docBody(): HTMLBodyElement {
    return this.win.nativeWindow.document.body as HTMLBodyElement;
  }

  @HostBinding('class.shrd-pf-ft-search-mobile') private readonly hostClass = true;

  @ViewChild('dropdown', { read: ElementRef, static: true }) private readonly dropdown: ElementRef<HTMLDivElement>;

  @HostListener('keydown', ['$event'])
  private onKeyDown(event: KeyboardEvent): void {
    this.keyboardControlService.handleKeyboardEvent(event);
  }

  constructor(
    private readonly suggestionService: SearchSuggestionService,
    private readonly keyboardControlService: SearchSuggestionKeyboardControlService,
    private readonly renderer: Renderer2,
    win: WindowRefService,
    cdr: ChangeDetectorRef
  ) {
    super(win, cdr);
  }

  openSearchPage(): void {
    super.open();
    this.renderer.addClass(this.docBody, BackDropClass.MODAL_OPEN);
  }

  closeSearchPage(): void {
    super.close();
    this.renderer.removeClass(this.docBody, BackDropClass.MODAL_OPEN);
  }

  transitionEndHandler(e: Event): void {
    if (!this.isOpen && e.currentTarget === e.target) {
      this.onClosed();
    }
  }

  updateLinkNodes(linkNodes: NodeListOf<HTMLElement>): void {
    this.keyboardControlService.updateLinkNodes(linkNodes);
  }
}
